import React from'react';

var ComponentTestPage=function ComponentTestPage(){return(
React.createElement("div",{className:"component-test-page container mx-auto"},
React.createElement("h1",null,"Component Test Page")));};



export default ComponentTestPage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9Db21wb25lbnRUZXN0UGFnZS9Db21wb25lbnRUZXN0UGFnZS5qc3giXSwibmFtZXMiOlsiUmVhY3QiLCJDb21wb25lbnRUZXN0UGFnZSJdLCJtYXBwaW5ncyI6IkFBQUEsTUFBT0EsTUFBUCxLQUFrQixPQUFsQjs7QUFFQSxHQUFNQyxtQkFBb0IsUUFBcEJBLGtCQUFvQjtBQUN4QiwyQkFBSyxVQUFVLHVDQUFmO0FBQ0Usb0RBREYsQ0FEd0IsR0FBMUI7Ozs7QUFNQSxjQUFlQSxrQkFBZiIsImZpbGUiOiJDb21wb25lbnRUZXN0UGFnZS5qc3giLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IENvbXBvbmVudFRlc3RQYWdlID0gKCkgPT4gKFxuICA8ZGl2IGNsYXNzTmFtZT1cImNvbXBvbmVudC10ZXN0LXBhZ2UgY29udGFpbmVyIG14LWF1dG9cIj5cbiAgICA8aDE+Q29tcG9uZW50IFRlc3QgUGFnZTwvaDE+XG4gIDwvZGl2PlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQ29tcG9uZW50VGVzdFBhZ2U7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/ComponentTestPage/ComponentTestPage.jsx
// module id = 2030
// module chunks = 0